import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatDialogModule } from '@angular/material/dialog'
import { CustomDatePipe } from './date.pipes'
import { NullToDashPipe } from './string.pipes'

@NgModule({
  declarations: [CustomDatePipe, NullToDashPipe],
  imports: [CommonModule, MatDialogModule],
  exports: [CustomDatePipe, NullToDashPipe]
})
export class SharedModule {}
